import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types'

export const TLanguages = t.array(
  t.strict({
    code: t.string,
    name: t.string,
    image: t.string,
  }),
)

export type ILanguages = t.TypeOf<typeof TLanguages>

export const TAppLanguages = t.array(
  t.strict({
    appLanguageId: t.string,
    code: t.string,
    createdAt: t.union([DateFromISOString, t.string]),
  }),
)
